<article class="dashboard-container" *ngIf="!loading; else loaderBlock">
  <!----- START OF HEAD SECTION ------>
  
  <!------ END OF HEAD SECTION ------->

  <!----- START OF CONTENT SECTION ------>
  <section class="content-section">
    <powerbi-report
      [embedConfig]="embedConfigDeal"
      cssClassName="reportClass"
      [phasedEmbedding] = " false "

    [eventHandlers]="eventHandlers"
    >
    </powerbi-report>
  </section>
  <ng-template #countInfoSkeletonLoader>
    <div class="motif-skeleton-container loader-container">
      <span class="motif-skeleton-12 loader"></span>
    </div>
  </ng-template>
  <!------ END OF CONTENT SECTION ------->

  <!----- START OF LINE SECTION ------>
  <section class="line-section">
    <!-- <img src="/assets/images/dashboard_lines.svg" alt="Dashboard Lines"/> -->
  </section>
  
  <!------ END OF LINE SECTION ------->
</article>
<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>

